import { useState, useEffect } from "react";
import { PocketBaseClient } from "../Api/PocketbaseClient.js";

const ONE_HOUR_IN_MS: number = 1000 * 60 * 60;

const connectPlayer = async (connectionId: string) => {
  const connection = await PocketBaseClient.collection("connected_players")
    .getFirstListItem(`id="${connectionId}"`, { requestKey: null })
    .catch((error) => {
      // TODO: add error handling
      return null;
    });

  if (!connection?.connectedAt) {
    await PocketBaseClient.collection("connected_players").update(
      connectionId,
      {
        connectedAt: new Date(),
      },
      { requestKey: null }
    );
    return { valid: true, userId: connection?.userId };
  }

  const connectionUTCTime = new Date(connection.connectedAt).toISOString();
  const currentUTCTime = new Date(Date.now() - ONE_HOUR_IN_MS).toISOString();

  if (connectionUTCTime > currentUTCTime) {
    console.log("CONNECTION IS STILL VALID");
    return { valid: true, userId: connection.userId };
  }
  return { valid: false, userId: null };
};

export const useConnectedPlayer = ({ connectionId }: { connectionId: string }) => {
  const [userId, setUserId] = useState<string | null>(null);
  const [isValid, setIsValid] = useState<boolean | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    setIsLoading(true);
    connectPlayer(connectionId).then((res) => {
      if (!res.valid) {
        setIsLoading(false);
        setIsValid(false);
        return;
      }
      setUserId(res.userId);
      setIsValid(true);
      setIsLoading(false);
    });
    console.log({ isValid, isLoading, userId });
  }, []);

  return { isValid, isLoading, userId };
};
